module.exports = __webpack_public_path__ + "media/point-1.9cf04e39.mp3";